import type { Fetcher } from 'swr'
import { del, get, post, patch } from './base'
import type {
  DeploymentDetailResponse,
  DeploymentListResponse,
} from '@/models/deployment'
import type { Deployment } from '@/types/deployment'

export const fetchDeploymentList: Fetcher<
  DeploymentListResponse,
  { params?: Record<string, any> }
> = ({ params }) => {
  return get('deployments', { params }) as Promise<DeploymentListResponse>
}

export const fetchDeploymentPodList = ({ id }: { id: string }) => {
  return get<Record<string, any>[]>(`deployments/${id}/pods`)
}

export const createDeployment: Fetcher<
  DeploymentDetailResponse,
  Deployment
> = request => {
  return post('deployments', {
    body: request,
  }) as Promise<DeploymentDetailResponse>
}

export const fetchDeploymentDetail = (id: string) => {
  return get<DeploymentDetailResponse>(`deployments/${id}`)
}

export const deleteDeployment = (id: string) => {
  return del<string>(`deployments/${id}`)
}

export const startDeployment = (id: string) => {
  return post<string>(`deployments/${id}/start`)
}

export const stopDeployment = (id: string) => {
  return post<string>(`deployments/${id}/stop`)
}

export const fetchDeploymentLog = (id: string) => {
  return get<string>(`deployments/${id}/log`)
}

export const scaleDeployment = (params: { replicas: number; id: string }) => {
  return post<Deployment>(`deployments/${params.id}/scale`, {
    body: { replicas: params.replicas },
  })
}

export const updateDeployment = (id: string, params: Deployment) => {
  return patch<Deployment>(`deployments/${id}`, {
    body: params,
  })
}
